import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-pdf-modal',
  templateUrl: './pdf-modal.component.html',
  styleUrls: ['./pdf-modal.component.scss']
})
export class PdfModalComponent implements OnInit {
	pdfUrl:string = "";

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: any,
		public dialogRef: MatDialogRef<PdfModalComponent>,
    private sanitizer: DomSanitizer
	) {
		if (data) {
      this.pdfUrl = data.url;
		}
	}

	ngOnInit() {}

  private sanitizedUrlCache = new Map<string, SafeResourceUrl>();

  sanitizePdfUrl(url: string): SafeResourceUrl {
    if (!this.sanitizedUrlCache.has(url)) {
      const sanitizedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
      this.sanitizedUrlCache.set(url, sanitizedUrl);
    }
    return this.sanitizedUrlCache.get(url)!;
  }
}

